<template lang="pug">
  modal(id="history-modal" name='history-modal' @before-open="beforeOpen" :scrollable="smallscreen ? true : false"  transition='pop-up', :width="smallscreen ? '100%' : '920px'", :height="'760px'" :class="smallscreen ? 'fullscreen' : ''")
    el-select(v-if="iframed" name="type" class="select-component" v-on:change="setComponent" label="type"  v-model="selected" :current="component" :popperAppendToBody="false" popper-class="historymodal")
      el-option( v-for="item in compoptions" :key="item.value" :label="item.label" :value="item.value" )
    .subscriber-overlay(v-if="subType == 0" v-on:click="rerun('close')" )
      .non-sub 
        H3 History is a premium feature
        p Subscribers can access a transaction log of all saved nMonte models, calculator runs, and PCA plots
        p The saved history log can be searched and models, calculators and plots can be rerun or viewed as desired.
    .history-modal-content(v-if="subType != 0")
      reactive-base.topcontainer( :onQueryChange="log" :key="app" :app="app" url="https://read-only:yj3j3v8t1lqgjymeryfshgwzbdockdsx@oin-us-east-1.searchly.com" )
        data-search(class="searchbox" componentId="SearchLabel" data-field='name' placeholder="Search within Title/Details" :fuzziness="'AUTO'" :debounce="500" :autosuggest="true" :react="{ and: ['userFilter']}" :highlight="false" :title="'Search'" )
        single-list(style="display:none;" componentId="userFilter" data-field='user' :showSearch="false" :showFilter="false" title="User" :showRadio="false" :defaultValue="user ? user.username : null" )
        multi-list( class="multi-list-container groups"  componentId="groupFilter" :showSearch="true" data-field='components' title="Groups/Components", :react="{ and: ['userFilter', 'SearchLabel']}")
          div(v-tooltip="label.replace(/_/g,' ')" slot="renderItem" class="group-item" slot-scope="{ label, count }") ({{count}}) {{label.replace(/_/g,' ')}}
        multi-list( class="multi-list-container samples"  componentId="sampleFilter" :showSearch="true" data-field='categories' title="Samples", :react="{ and: ['userFilter', 'SearchLabel']}")
          div(v-tooltip="label.replace(/_/g,' ')" slot="renderItem" class="group-item" slot-scope="{ label, count }") ({{count}}) {{label.replace(/_/g,' ')}}
        reactive-list(:onQueryChange="log" :debug="true" componentId="SearchResult" data-field="date" :pagination="true" sortBy="desc" :from="0" :size="22" :react="{ and: ['userFilter','groupFilter', 'sampleFilter'], or: 'SearchLabel'}" :showResultStats="true" class="result-list-container" :inner-class="{ pagination: 'result-pagination', renderItem: 'history-slot', noResults: 'no-results' }")
            div(slot="render" class="history-content" slot-scope="{ data }")
              table(v-if="data.length > 0")
                thead
                  tr
                    th.redo(v-if="!iframed") 
                    th.date Date 
                    th.time Time
                    th.details Details
                tbody( v-for="item in (data || [])" )
                  tr
                    td.redo(v-if="!iframed" v-on:click="rerun(item)" v-tooltip="`<b>Re-${(component === 'g25' ? 'run' : 'plot')} ${(component === 'g25' ? 'Model' : 'PCA')}</b>`")
                      i.fas.fa-redo(v-if="checkType(item)")
                    td.date {{ new Date(item.date).toLocaleString().split(',')[0] }}
                    td.time {{ ('0' +  new Date(item.date).toLocaleString().split(',')[1].replace(/ /,'')).slice(-11) }}
                    td.details
                      a(v-if="component == 'admix2'" key="item._id" target="_blank" :href="`https://genoplot.com/shared/${item.type}/?share=${item.path + '#' + item.theme}`") 
                        span(v-tooltip="tooltip(item)") {{ item.name ? item.name.substr(0,40) + '...' : item.categories && item.categories[0] ? (item.categories[0].split(':').length > 1 ? item.categories[0].split(':')[1].split('@')[0] : item.categories[0].split(' ').reverse()[0]).split('@')[0] : ''}} {{ item.name ? '' : item.components ? '| ' +   item.components.join(', ').replace(/_/g, ' ').substr(0,15) + '...' : '' }}
                      div.progress_status(:class="item.status == 'error' ? 'error' : ''" v-if="item.status && item.status != 'completed'" key="item._id" target="_blank" v-on:click="view({name: (item.name.split(': ').length > 1 ? item.name.split(': ')[1].substr(0,40) : item.name.substr(0,40)) + '...',  time: `${ new Date(item.date).toLocaleString().split(',')[0] } ${ ('0' +  new Date(item.date).toLocaleString().split(',')[1].replace(/ /,'')).slice(-11) }`, status: item.status, name: item.name})")
                        span(v-tooltip="tooltip(item)") {{ item.name.substr(0,40) + '...' }}
                      div(v-if="component != 'admix2' && (!item.status || item.status && item.status == 'completed')" key="item._id" target="_blank" v-on:click="view(`https://genoplot.com/shared/${item.type}/?share=${item.path}||${item.name ? item.name.substr(0,40) + '...' : item.categories && item.categories[0] ? (item.categories[0].split(':').length > 1 ? item.categories[0].split(':')[1].split('@')[0] : item.categories[0].split(' ').reverse()[0]).split('@')[0] : ''} ${item.name ? '' : item.components ? '| ' +   item.components.join(', ').replace(/_/g, ' ').substr(0,15) + '...' : ''}`)"  :href="`https://genoplot.com/shared/${item.type}/?share=${item.path + '#' + item.theme}`")
                        span(v-tooltip="tooltip(item)") {{ item.name ? item.name.substr(0,40) + '...' : item.categories && item.categories[0] ? (item.categories[0].split(':').length > 1 ? item.categories[0].split(':')[1].split('@')[0] : item.categories[0].split(' ').reverse()[0]).split('@')[0] : ''}} {{ item.name ? '' : item.components ? '| ' +   item.components.join(', ').replace(/_/g, ' ').substr(0,15) + '...' : '' }}
</template>
<script>
import copy from 'copy-html-to-clipboard';
export default {
    name: 'HistoryModal',
    data() {
        return {
            component: false,
            compoptions: [{
                label: 'Admixture Calculators',
                value: 'admix'
            }, {
                label: 'nMonte Runner',
                value: 'g25'
            }, {
                label: 'PCA Plots',
                value: 'pca'
            }],
            selected: 'pca',
            iframed: false
        }
    },
    computed: {
        slider: function() {
            return this.$store.getters.get('slider')
        },
        nonSub: function() {
            let content = "<b>History is a premium feature</b><br/>Subscribers can access a transaaction log of all saved nMonte models, Admixture calculator runs and PCA plots<br/>These saved models, calculators and plots can be reprun with modifications or viewed as desired."
            return content
        },
        subs: function() {
            return this.$store.getters.get('subscription')
        },
        subType() {
            return this.subs && this.subs.subType && this.subs.subType.indexOf('gold') >= 0 ? 2 : this.subs && this.subs.subType && this.subs.subType.indexOf('silver') >= 0 ? 1 : 0
        },
        user: function() {
            return this.$store.getters.get('user')
        },
        app: function() {
            let component = this.component === 'discussions' ? 'search.pca' : this.component === 'admix' ? 'search-' + this.component : this.component ? 'search.' + this.component : 'search'
            console.log('app', component)
            return component
        },
        smallscreen: function() {
            return this.$store.getters.get('smallscreen')
        },
    },
    methods: {
        log(evt) {
        console.log('evt', evt)
        },
        recordEvent: function(evt, meta) {
            let ignore = []
            meta.component = this.component;
            this.$gtag.event(evt, meta);
            if (ignore.indexOf(evt.toLowerCase()) < 0 && this.$genericevent) this.$genericevent.trackEvent(evt, meta);
        },
        getInitialColorMode(value) {
            const persistedColorPreference = value == 'system' ? false : value
            const hasPersistedPreference = typeof persistedColorPreference === 'string';
            if (hasPersistedPreference) {
                this.setColors(persistedColorPreference)
                return persistedColorPreference;
            }
            const mql = window.matchMedia('(prefers-color-scheme: dark)');
            const hasMediaQueryPreference = typeof mql.matches === 'boolean';
            if (hasMediaQueryPreference) {
                this.setColors(mql.matches ? 'dark' : 'light')
                return mql.matches ? 'dark' : 'light';
            }
            this.setColors('light')
            return 'light';
        },
        setColors(value) {
            if (value == 'dark') {
                document.documentElement.style.setProperty('--bg-color', '#181818');
                document.documentElement.style.setProperty('--color', '#dfdfdf');
            } else {
                document.documentElement.style.setProperty('--bg-color', '##f2f2f2');
                document.documentElement.style.setProperty('--color', '#444444');
            }
        },
        toggleTheme() {
            let value = this.slider.theme && this.slider.theme.value && typeof(this.slider.theme.value) == 'string' ? this.slider.theme.value.toLowerCase() : 'system'
            //this.syncStore('slider.theme.' + value)
            let genoTheme = this.getInitialColorMode(value)
            localStorage.setItem("genoTheme", genoTheme);
                        let wn = document.getElementById('discussionframe')
                        if (wn && wn.contentWindow) {
                            wn = wn.contentWindow
                            if ( value == 'system' ) {
                            wn.postMessage({
                                action: 'removeStorage',
                                content: { key: 'genoTheme'},
                                source: 'genoplot.com'
                            }, '*')
                            } else {
                            wn.postMessage({
                                action: 'setStorage',
                                content: { key: 'genoTheme', value: genoTheme },
                                source: 'genoplot.com'
                            }, '*')
                            }
                        }
            const el = document.body;
            if (el.classList.contains('dark') && genoTheme != 'dark') {
                el.classList.remove('dark')
            } else if ( genoTheme == 'dark' ) {
                el.classList.add('dark')
            }
        },
        unescape: value => {
            return unescape(value)
        },
        setComponent: function() {
        this.component = this.selected
        console.log('setting comp', this.component)
        },
        view: function(url) {
            this.recordEvent(`history-view-${this.component}`, {
                'event_category': 'function',
                'event_label': 'User initiated'
            })
            if ( url.status && url.time && url.name ) {
            let name =  url.name.split(': ').length > 1 ?  url.name.split(': ')[1] : url.name
            this.$modal.show('dialog', { text: `${name}<br>Status<br><b>${url.time}:&nbsp;&nbsp;${url.status.toUpperCase()}</b>`, class: url.status == 'error' ? 'warning' : 'alert' })
            return;
            }
            let value = this.slider.theme && this.slider.theme.value && typeof(this.slider.theme.value) == 'string' ? this.slider.theme.value.toLowerCase() : 'system'
            let genoTheme = this.getInitialColorMode(value)
            if (!this.subType || this.subType == 0) {
                this.$modal.hide('history-modal');
                return;
            }
            if (url) {
                let obj = {}
                obj[`sharedurl`] = url
                this.$store.commit('change', obj)
            }
            this.$modal.hide('history-modal');
            url = url.split('||')[0]
            if (url.includes('/#')) {
                let hash = '#' + url.slice(-1)
                url = url.replace(/\/#/, '/?share=').slice(0, -1) + hash;
            }
            copy(url)
            this.$toasted.show('<b>URL for share copied to clipboard</b>', {
                position: 'top-center',
                duration: 5000,
                containerClass: 'allover',
                className: 'topToast'
            })
            //this.$modal.show('dialog', { text: '<b>URL for share copied to Clipboard!</b>', class: 'alert' })
            //this.$router.push('/shares')
            if (this.$store.getters.get('showshare')) {
                this.$store.commit('change', {
                    showshare: false
                })
                setTimeout(() => {
                    this.$store.commit('change', {
                        showshare: true
                    })
                }, 600)
            } else {
                this.$store.commit('change', {
                    showshare: true
                })
            }
        },
        defaultQuery: function(value, props) {
            return {
                query: {
                    match: {
                        user: this.user.username
                    }
                }
            }
        },
        tooltip: function(item) {
            let string = '<b style="color:silver;font-weight:400;">Click to view and copy URL to clipboard</b></br>'
            if ( item.status ) {
            string = '<b style="color:silver;font-weight:400;">Click to view current status</b></br>'
            return string;
            }
            if (item.calculator && typeof(item.calculator) == 'string') string = string + `<b>Calculator</b><br>${unescape(item.calculator.split(':')[1])} by ${item.calculator.split(':')[0]}<br/>`
            if (item.categories && item.categories[0]) string = string + '<b>Samples</b><br>' + item.categories.map(x => x.split('@')[0]).join(', ').substr(0, 200) + '...<br>'
            if (item.components) string = string + '<b>Groups</b></br>' + item.components.join(', ').replace(/_/g, ' ').substr(0, 400) + '...'
            if (item.mode && item.modetype && item.type !== 'pca') string = string + '<br><b>Mode</b></br>' + item.modetype
            if (item.type === 'pca' && item.reference && item.reference[0]) string = string + '<br><b>Reference</b></br>' + item.reference[0].replace(/_/g, ' ').replace(/:/, ' ► ').split('@')[0]
            if (item.type === 'pca' && item.mode) {
                string = string + '<br><b>2D PCA</b>'
                if (item.modetype) string = string + ' <b>(' + item.modetype + ')</b>'
            } else if (item.type === 'pca') {
                string = string + '<br><b>3D PCA</b>'
                if (item.modetype) string = string + ' <b>(' + item.modetype + ')</b>'
            }
            return string
        },
        checkType: function(item) {
            //return item.type === 'pca' || item.groupArray && item.components.indexOf(item.groupArray[0].split(':')[0]) >= 0 || item.calculator ? true : false;
            return item.type === 'pca' || item.type === 'g25' || (item.calculator && item.type !='analysis') ? true : false;
        },
        rerun: function(params) {
            if (params == 'close' || !this.subType || this.subType == 0) {
                this.$modal.hide('history-modal');
                return;
            }
            this.$eventBus.$emit('appEvents', {
                exec: 'rerun',
                component: params.type,
                params: params
            })
            this.recordEvent(`history-rerun-${params.type}`, {
                'event_category': 'function',
                'event_label': 'User initiated'
            })
            this.$modal.hide('history-modal');
        },
        beforeOpen(evt) {
            console.log('opening ', evt)
            this.selected = 'pca'
            this.component = evt.params ? evt.params.component : false;
            this.iframed = this.component == 'discussions' ? true : false
        },

        beforeClose() {},

        opened(e) {},

        closed(e) {}
    },
    components: {},
    mounted() {}
}
</script>
<style>
.history-modal-content {
    padding: 20px 40px;
}

body #app #history-modal .subscriber-overlay {
    width: 100%;
    height: 100%;
    position: absolute;
    z-index: 9;
    background: transparent;
    pointer-events: all;
    display: flex;
    justify-content: center;
    align-items: center;
}

body #app #history-modal .subscriber-overlay .non-sub {
    width: 50%;
    color:#313030;
    padding: 20px;
    border-radius: 5px;
    text-align: center;
}

div.topcontainer {
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    height: 720px;
}

.row {
    display: flex;
    flex-direction: row;
    width: 100%;
}

.row.dark {
    background: #303030;
}

.col {
    width: calc(100% - 400px);
    padding: 15px;
}

.row>.col:first-child {
    border-right: 1px solid #ccc;
    max-width: 400px;
}

.result-list-container {
    width: 75%;
    padding: 0 10px 0 60px;
}

.result-list-container>div:not(:first-child) {
    margin-bottom: 20px;
    margin-top: 0px;
}

.result-list-container .no-results {
    position: absolute;
    top: 20px;
    left: 0;
    color: #2e668c;
    font-weight: 700;
    width: 100%;
    text-align: center;
    margin: 0;
}

#history-modal .searchbox {
margin-top: 10px;
margin-bottom: 20px;
}
#history-modal .searchbox .search-icon { 
display: none;
}
#history-modal .searchbox .cancel-icon { 
margin-bottom: 6px;
}
#history-modal .searchbox input {
border-radius: 9px;
max-height: 36px;
padding-left: 12px;
}
#history-modal .searchbox>h2 {
    font-size: 1em;
    margin-bottom: 20px;
    font-weight: 700;
}
#history-modal li .group-item {
word-break: break-all;
text-overflow: ellipsis;
white-space: nowrap;
max-width: 172px;
overflow-x: hidden;
}

.multi-list-container {
    width: 25%;
    overflow-x: hidden;
    justify-content: space-around;
    max-height: calc(50% - 70px);
    margin-bottom: 0px;
}

.multi-list-container ul {
    overflow-x: hidden;
    max-height: calc(100% - 110px);
    margin-top: 10px;
    width: calc(100% + 20px);
}

.multi-list-container label {
    margin-left: 5%;
    font-size: 0.8em;
}

.multi-list-container>input {
    border-radius: 9px;
    max-height: 36px;
    margin-bottom: 10px;
}

.multi-list-container>h2 {
    font-size: 1em;
    margin-bottom: 20px;
    font-weight: 700;
}

.result-list-container table td {
    padding: 2px 5px 1px 0px;
}

.result-list-container table td.details div {
    color: #2e668c;
}

.result-list-container table td.details div:hover {
    cursor: pointer;
    text-decoration: underline;
}

.result-list-container table tbody td.time {
    text-align: left;
}

.result-list-container table tbody td.redo i {
    color: #2e668c88;
    font-size: 0.8em;
    margin-right: 5px;
    cursor: pointer;
}

.result-list-container table tbody td.redo:hover i {
    color: #2e668c;
}

.multi-list-container.groups {}

.multi-list-container.samples {}

.history-content {
    min-height: 580px;
}

.history-content td {
    color: gray;
}

.history-content a,
.history-content a:hover {
    color: #2e668c;
}

.result-list-container thead th {
    padding-bottom: 10px;
}

.result-pagination a.active,
.result-pagination a.active:hover,
.result-pagination a.active:focus {
    background-color: #2e668c;
    border-color: none;
}

.result-pagination a:not([disabled]):hover,
.result-pagination a:not([disabled]):focus {
    color: white;
}

.result-pagination a:not([enabled]):not(.active):hover,
.result-pagination a:not(.active):not([enabled]):focus {
    color: gray;
    text-decoration: none;
}

body.app-page .tooltip-inner {
    padding: 10px 20px;
    background: #f9f9f9;
    color: #444;
    border-radius: 5px;
    border-color: white;
    box-shadow: 0 5px 30px rgba(black, .1);
}

body.app-page .toasted-container.allover {
    z-index: 9999;
    width: 100%;
}

body.app-page .toasted-container.allover .topToast {
    position: fixed;
    background: transparent;
    left: calc(50% - 172px);
    top: -80px !important;
    color: white;
    box-shadow: none;
}
body #history-modal .select-component {
position: absolute;
right:10px;
top: 0px;
width: 240px;
border-radius: 3px;
text-align: right;
}
body #history-modal .el-select .el-input .el-select__caret {
color: gray !important;
}
body #history-modal .select-component input {
background: white;
    color: #2e668c;
    font-family: -apple-system,BlinkMacSystemFont,"Segoe UI","Roboto","Noto Sans","Ubuntu","Droid Sans","Helvetica Neue",sans-serif;
    font-weight: 700;
    font-size: 1.1em;
    text-align: right;
        padding-right: 50px;
    }
body #history-modal .el-select .el-input .el-input__inner:hover {
    box-shadow: none;
    }
    body.discussions  .el-select-dropdown.el-popper {
    z-index: 999999 !important;
    }
    .el-select-dropdown.el-popper.historymodal {
    min-width: 200px !important;
    margin-right: -100px !important;
    }
body #history-modal div.progress_status {
color: #878f00;
font-weight: 700;
}
body #history-modal div.progress_status.error {
color: #8e0c0c;
}
color: #878f00;
</style>
